module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerBold.8b23c9a4.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerBold.otf
// module id = 1060
// module chunks = 0